<template>
  <div class="bg-gray-100">
    <button
      class="my-3 flex h-10 w-full items-center px-3"
      :title="menuData.parent.name"
      @click="handleClick(menuData.parent.id)"
    >
      <IconCaret direction="left" class="mr-2 h-6 w-6 basis-6 text-blue-400" />
      <span class="line-clamp-1 text-base font-bold text-blue-400">
        {{ menuData.parent.name }}
      </span>
    </button>
    <div class="container-wrap mb-3 border-b border-solid border-gray-400">
      <div class="py-2">
        <strong class="text-lg font-bold text-black">
          {{ menuData.name }}
        </strong>
      </div>
      <div v-if="menuData.link" class="mb-3 flex items-center">
        <TheButton
          :to="menuData.link.url"
          :title="buttonName"
          class="flex items-center"
        >
          <span class="flex-1 truncate text-sm !leading-5">
            {{ buttonName }}
          </span>
          <IconCaret direction="right" class="ml-1 h-5 w-5 text-white" />
        </TheButton>
      </div>
    </div>
    <nav class="container-wrap">
      <ul class="py-3">
        <li
          v-for="item in menuData.subMenus"
          :key="item.id"
          class="mb-2 w-full py-2"
        >
          <button
            v-if="item.hasSubMenu"
            class="flex w-full items-center justify-between text-left text-base font-bold hover:text-blue-500"
            :class="
              item.code === 'free-trial' || item.code === 'free-trials'
                ? 'text-orange-400'
                : 'text-black/70'
            "
            :title="item.name"
            @click="handleClick(item.id)"
          >
            <span>{{ item.name }}</span>
            <div class="flex items-center">
              <TheBadge v-if="item.isHot" name="HOT" theme="red" class="mr-1" />
              <TheBadge
                v-if="item.isNew"
                name="NEW"
                theme="orange"
                class="mr-1"
              />
              <TheBadge
                v-if="item.isSuite"
                name="SUITE"
                theme="blue"
                class="mr-1"
              />
              <IconCaret
                direction="right"
                class="h-6 w-6 basis-6 text-gray-400"
              />
            </div>
          </button>
          <TheNuxtLink
            v-else
            :to="item.link?.url || ''"
            :title="item.name"
            class="flex w-full items-center justify-between text-left text-base font-bold text-black/70 hover:text-blue-400"
          >
            <span>{{ item.name }}</span>
            <div class="flex items-center">
              <TheBadge v-if="item.isHot" name="HOT" theme="red" class="mr-1" />
              <TheBadge
                v-if="item.isNew"
                name="NEW"
                theme="orange"
                class="mr-1"
              />
              <TheBadge
                v-if="item.isSuite"
                name="SUITE"
                theme="blue"
                class="mr-1"
              />
            </div>
          </TheNuxtLink>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script setup lang="ts">
  import type { IFlattenItem } from '@/components/Layout/Menu/Mobile/types';

  interface IProps {
    type: string;
    menuData: IFlattenItem;
  }

  const props = withDefaults(defineProps<IProps>(), {
    type: '',
  });

  const { t } = useI18n();

  const menuStore = useMenuStore();
  const { menuName, currentMobileMenu } = storeToRefs(menuStore);

  const buttonName = computed((): string => {
    return props.type === menuName.value.SOLUTIONS
      ? t('menu.content.overview-button')
      : t('menu.content.view-all-button');
  });

  const handleClick = (id: string): void => {
    currentMobileMenu.value = id || null;
  };
</script>
